import { render, staticRenderFns } from "./PDPProductAlsoBought.vue?vue&type=template&id=630c3036&scoped=true"
import script from "./PDPProductAlsoBought.vue?vue&type=script&lang=js"
export * from "./PDPProductAlsoBought.vue?vue&type=script&lang=js"
import style0 from "./PDPProductAlsoBought.vue?vue&type=style&index=0&id=630c3036&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630c3036",
  null
  
)

export default component.exports